export enum LoginMethodEnum {
    Password = 0,
    GoogleSso = 1,
    MicrosoftSso = 2,
}

export const LoginMethodLabels: Record<LoginMethodEnum, string> = {
    [LoginMethodEnum.Password]: LoginMethodEnum[LoginMethodEnum.Password],
    [LoginMethodEnum.GoogleSso]: 'Google SSO',
    [LoginMethodEnum.MicrosoftSso]: 'Microsoft SSO',
};

export function getLoginMethodLabel(value?: number | string | null): string {
    if (value == null) {
        return '-';
    }

    if (typeof value === 'number') {
        return LoginMethodLabels[value as LoginMethodEnum] ?? '-';
    }

    const normalizedValue = value.trim();
    if (normalizedValue.length === 0) {
        return '-';
    }

    const parsedValue = Number.parseInt(normalizedValue, 10);
    if (!Number.isNaN(parsedValue)) {
        return LoginMethodLabels[parsedValue as LoginMethodEnum] ?? '-';
    }

    const normalizedKey = normalizedValue.toLowerCase().replace(/[_\s]/g, '');
    switch (normalizedKey) {
        case 'password':
            return LoginMethodLabels[LoginMethodEnum.Password];
        case 'googlesso':
            return LoginMethodLabels[LoginMethodEnum.GoogleSso];
        case 'microsoftsso':
            return LoginMethodLabels[LoginMethodEnum.MicrosoftSso];
        default:
            return '-';
    }
}
